import { AndroidLogo, AppleLogo, JavascriptLogo, Typography } from '@compass/components'

import { IdentificationUrlKeys } from '../../../types'
import { visitFilterLabelMap } from '../../../utils/const'
import { CellAction } from './CellAction'
import { columnHelper } from './columnHelper'
import { Unavailable } from './MissingData'

export const sdkColumn = () =>
  columnHelper.display({
    id: 'sdk',
    header: 'SDK',
    cell: ({ row }) => {
      const sdk = row.original.sdk

      if (!sdk) {
        return <Unavailable />
      }

      const sdkPlatform = sdk.platform === 'unknown' ? undefined : sdk.platform

      return (
        <CellAction
          copyValue={sdk.version}
          field={IdentificationUrlKeys.SdkVersion}
          fields={[
            visitFilterLabelMap[IdentificationUrlKeys.SdkPlatform],
            visitFilterLabelMap[IdentificationUrlKeys.SdkVersion],
          ]}
          search={(old) => ({
            ...old,
            [IdentificationUrlKeys.SdkPlatform]: sdkPlatform,
            [IdentificationUrlKeys.SdkVersion]: sdk.version,
          })}
          className='min-w-28'
        >
          <div className='flex flex-row gap-2 items-center'>
            {sdk.platform === 'android' && <AndroidLogo className='size-4 shrink-0' />}
            {sdk.platform === 'ios' && <AppleLogo className='size-4 shrink-0' />}
            {sdk.platform === 'js' && <JavascriptLogo className='size-4 shrink-0' />}
            <Typography className='text-nowrap'>{sdk.version}</Typography>
          </div>
        </CellAction>
      )
    },
  })
